import { createContext, useContext, useState } from "react";

const SimplifyContext = createContext(null);

export function SimplifyProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <SimplifyContext.Provider value={{ open, setOpen }}>
      {children}
    </SimplifyContext.Provider>
  );
}

export function useSimplify() {
  return useContext(SimplifyContext);
}
